
import { Link } from 'react-router-dom';

export default function AuthorHeader() {
  return (
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <nav className="flex items-center space-x-2 text-sm text-gray-600">
          <Link to="/" className="hover:text-blue-600">Home</Link>
          <i className="ri-arrow-right-s-line text-gray-400"></i>
          <Link to="/blog" className="hover:text-blue-600">Blog</Link>
          <i className="ri-arrow-right-s-line text-gray-400"></i>
          <span className="text-gray-900">Author</span>
        </nav>
      </div>
    </div>
  );
}